import React from 'react';

const ALL_STEPS = [
    { key: 'select',     label: 'Select Files' },
    { key: 'uploading',  label: 'Files Uploading' },
    { key: 'indexing',   label: 'Indexing & Analyzing' },
    { key: 'allocation', label: 'Allocation' },
    { key: 'processing', label: 'Saving & Indexing' },
];

const TempAutoFillStepper = ({ currentStep }) => {
    const currentIndex = ALL_STEPS.findIndex(s => s.key === currentStep);
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.25rem 1rem 0.75rem', gap: 0, width: '100%' }}>
            {ALL_STEPS.map((step, i) => {
                const isDone = i < currentIndex;
                const isActive = i === currentIndex;
                return (
                    <React.Fragment key={step.key}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '72px' }}>
                            <div style={{
                                width: '28px', height: '28px', borderRadius: '50%',
                                background: isDone ? '#22c55e' : isActive ? '#3B82F6' : '#E5E7EB',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                {isDone
                                    ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    : <span style={{ fontSize: '11px', fontWeight: 700, color: isActive ? '#fff' : '#9CA3AF' }}>{i + 1}</span>
                                }
                            </div>
                            <span style={{ fontSize: '10px', marginTop: '4px', fontWeight: isActive ? 700 : 400, color: isActive ? '#1D4ED8' : isDone ? '#059669' : '#9CA3AF', whiteSpace: 'nowrap' }}>
                                {step.label}
                            </span>
                        </div>
                        {i < ALL_STEPS.length - 1 && (
                            <div style={{ height: '2px', flex: 1, background: isDone ? '#22c55e' : '#E5E7EB', marginBottom: '18px' }} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default TempAutoFillStepper;
